import { AppState, ThunkDispatch } from "redux/store.types";
import { ViewTypes } from "types/issues.types";
import { fetchOrdersByCustomer } from "services/sales/orders/orders.service";

export const SET_SALES_SELECTED_MODULE = "SET_SALES_SELECTED_MODULE";
export const SET_SALES_ORDERBY_VALUE = "SET_SALES_ORDERBY_VALUE";
export const SET_SALES_SELECTED_BOX = "SET_SALES_SELECTED_BOX";
export const SET_SALES_VIEW_TYPE = "SET_SALES_VIEW_TYPE";
export const RESET_SALES_ISSUES = "RESET_SALES_ISSUES";
export const SET_ISSUES_BY_CUSTOMER = "SET_ISSUES_BY_CUSTOMER";

export const setSelectedModule = (moduleId: string) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_SALES_SELECTED_MODULE, payload: moduleId });
};

export const setOrderBy = (orderBy: string) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_SALES_ORDERBY_VALUE, payload: orderBy });
};

export const setSelectedBox = (boxId: string, moduleId: string) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch(setSelectedModule(moduleId));
  dispatch({ type: SET_SALES_SELECTED_BOX, payload: boxId });
};

export const setViewType = (viewType: ViewTypes) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_SALES_VIEW_TYPE, payload: viewType });
};

export const setIssuesByCustomer = (
  page: number,
  channelId: number,
  vendorId: number,
  uid: string
) => async (dispatch: ThunkDispatch, getState: () => AppState) => {
  const issuesByCustomer = await fetchOrdersByCustomer(
    page,
    channelId,
    vendorId,
    uid
  );
  if (!issuesByCustomer) {
    return false;
  }
  dispatch({
    type: SET_ISSUES_BY_CUSTOMER,
    payload: { page, channelId, vendorId, issuesByCustomer }
  });
  return true;
};

export const resetSalesIssues = () => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: RESET_SALES_ISSUES });
};
